declare global {
  interface Window {
    _uxa?: unknown[][];
  }
}

const CONTENTSQUARE_TAG_URL = import.meta.env.VITE_CONTENTSQUARE_TAG_URL;
const PII_SELECTORS = "td, .MuiDialogContent-root, .MuiMenu-list, .MuiAutocomplete-listbox";

if (CONTENTSQUARE_TAG_URL) {
    window._uxa = window._uxa || [];
    window._uxa.push(["setPIISelectors", { PIISelectors: PII_SELECTORS }]);

    const script = document.createElement("script");
    script.async = true;
    script.src = CONTENTSQUARE_TAG_URL;
    document.head.appendChild(script);
}

export function trackUserSegment(role: string, companyId: number): void {
  if (!CONTENTSQUARE_TAG_URL) {
    return;
  }

  window._uxa = window._uxa || [];

  window._uxa.push(["setCustomVariable", 1, "Role", role, "visit"]);
  window._uxa.push(["setCustomVariable", 2, "CompanyId", String(companyId), "visit"]);
}
